<template>
  <div>
    <div class="cs-form-intro-large pt-8 pb-8">{{ $t('upload.title') }}</div>
    <template v-if="showUploadControl">
      <div id="upload-area" v-cloak @drop.prevent="addFile" @dragover.prevent>
        <div id="inner-upload-area">
          <span class="inner-upload-area">
            {{ $t('upload.dragAndDrop') }}
          </span>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="upload-spinner-text secondary--text text-center pt-10 pb-8">
        {{ $t('upload.subtitle') }}
      </div>
      <div id="upload-spinner" class="text-center">
        <v-progress-linear indeterminate rounded height="7" color="primary"></v-progress-linear>
      </div>
    </template>
  </div>
</template>

<script>
const fb = require('../firebaseConfig.js');
export default {
  data() {
    return {
      showUploadControl: true,
      files: [],
    };
  },
  computed: {
    uploadDisabled() {
      return this.files.length === 0;
    },
  },
  methods: {
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;

      if (!droppedFiles) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      /*       [...droppedFiles].forEach(f => {
        this.files.push(f);
      }; */
      const file = droppedFiles[0];
      this.upload(file);
    },
    removeFile(file) {
      this.files = this.files.filter((f) => {
        return f != file;
      });
    },
    upload(file) {
      const fileName = file.name;
      if (!fileName.match(/.(pdf|PDF)$/i)) {
        /* self.showChoiceScreen();
        self.$notify({
          type: "error",
          title: self.$t("errors.forms.errorImageNotImageTitle"),
          text: self.$t("errors.forms.errorImageNotImageContent")
        }); */
        alert('Le fichier doit être un PDF');
      } else if (fileName.lastIndexOf('.') <= 0) {
        /*         self.showChoiceScreen();
        self.$notify({
          type: "error",
          title: self.$t("errors.forms.errorImageFileInvalidTitle"),
          text: self.$t("errors.forms.errorImageFileInvalidContent")
        }); */
        alert("Le fichier n'est pas correct.");
      } else {
        this.showUploadControl = false;
        const userId = this.$store.state.userProfile.userId;
        const csDocRef = fb.db
          .collection('allGeneratedCs')
          .doc(userId)
          .collection('cs')
          .doc();

        const csDocId = csDocRef.id;
        const greenCardFileName = csDocId + '.' + fileName.split('.').pop();

        const storageRef = fb.storage.ref();
        const fileRef = storageRef.child(
          'greenCardsToOCR/' + userId + '/' + greenCardFileName
        );

        const metadata = {
          customMetadata: {
            contentType: file.type,
            creatorId: userId,
            csDocId: csDocId,
          },
        };

        if (userId === "kigsvnB4gQY53LU1y2w8hm1lfAm2" || userId === "RVwTNbzVUgeWXketkAOqtsy2RRE2" || userId === "loBKsP6gGnfopKZI66yD0kganzV2") {
          fileRef
            .put(file, metadata)
            .then(() => {
              const extractCardData = fb.fnct.httpsCallable('extractCardData');
              return extractCardData({
                fileName: 'greenCardsToOCR/' + userId + '/' + greenCardFileName,
              });
            })
            .then((result) => {
              console.log(JSON.stringify(result));
              this.$store.commit('updateCsData', result.data);
              this.$router.push('verify');
            })
            .catch((error) => {
              console.error('extractCardData error:', error.code, error.message, error.details);
              this.showUploadControl = true;
              alert('Une erreur est survenue lors du traitement du fichier.');
            });
        } else {
          fileRef
            .put(file, metadata)
            .then(() => {
              const ocrGreenCard = fb.fnct.httpsCallable('greenCardOCR3');
              return ocrGreenCard({
                fileName: 'greenCardsToOCR/' + userId + '/' + greenCardFileName,
              });
            })
            .then((result) => {
              // eslint-disable-next-line no-console
              if (result.data.mode === 'mtz') {
                //alert('EMAIL');
              } else {
                this.$store.commit('updateCsData', result.data);
                this.$router.push('verify');
              }
            })
            .catch((error) => {
              console.error('greenCardOCR3 error:', error.code, error.message, error.details);
              this.showUploadControl = true;
              alert('Une erreur est survenue lors du traitement du fichier.');
            });
        }


      }
    },
  },
};
</script>

<style>
#upload-area {
  height: 200px;
  width: 100%;
  background-color: #d4eaff;
  border-style: dashed;
  border-color: #1976d2;
  display: flex;
  align-items: center;
  justify-content: center;
}

#inner-upload-area {
  width: 278px;
  height: 50px;
  font-family: 'Raleway', sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 800;
  line-height: 1;
  color: #b0d1f1;
}

.upload-spinner-text {
  font-family: 'Raleway', sans-serif;
  font-size: 27px;
  font-style: normal;
  font-weight: 800;
  line-height: 1;
  color: #1976d2;
}
</style>
